module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/refinance.svg?dbc2afc84c2159b39969a061b1171f03";